import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { WorkOrderModuleCategoriesSettings } from 'lane-shared/domains/workOrder';
import {
  buildCategoryItems,
  buildIssueTypeItems,
  findSelectedCategory,
  DropdownOption,
} from './coverageHoursPanelUtils';
import {
  CoverageHoursCategoryOption,
  CoverageHoursIssueTypeOption,
} from './useCoverageHoursOptions';

type UseCoverageHoursPanelOptionsResult = {
  categoryItems: DropdownOption[];
  selectedCategory: WorkOrderModuleCategoriesSettings | undefined;
  issueTypeItems: DropdownOption[];
};

export function useCoverageHoursPanelOptions(
  categories: WorkOrderModuleCategoriesSettings[],
  categoryValue: string | null,
  categoryOptions: CoverageHoursCategoryOption[],
  issueTypeOptions: CoverageHoursIssueTypeOption[]
): UseCoverageHoursPanelOptionsResult {
  const { t } = useTranslation();

  const categoryItems = useMemo(
    () => buildCategoryItems(categories, categoryOptions),
    [categories, categoryOptions]
  );

  const selectedCategory = useMemo(
    () => findSelectedCategory(categories, categoryValue),
    [categories, categoryValue]
  );

  const issueTypeItems = useMemo(
    () => buildIssueTypeItems(selectedCategory, issueTypeOptions, t),
    [selectedCategory, issueTypeOptions, t]
  );

  return { categoryItems, selectedCategory, issueTypeItems };
}
